import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { DangerBadge, Link as StyleGuideLink } from '@tmapy/style-guide';

import './IprDocumentItem.scss';

import { createDownloadLink } from '../../hooks';
import { FileIconWithBadge } from '../../docs/components/FileIconWithBadge';

import { iprDocumentMessages } from './iprDocumentMessages';

type IprDocumentItemProps = {
  /** URL entity z API — cesta k dokladu se na ni lepí, funguje pro objednávku dat i služby. */
  resourceUrl: string;
  docType: string;
  label: React.ReactNode;
  /** Doplněk k popisku, typicky číslo dokladu a datum vystavení. */
  note?: React.ReactNode;
};

export const IprDocumentItem: React.FC<IprDocumentItemProps> = React.memo(
  ({ resourceUrl, docType, label, note }) => {
    const [isError, setIsError] = useState(false);
    const downloadLink = useMemo(
      () =>
        createDownloadLink(
          `${resourceUrl}ipr_documents/${docType}/`,
          undefined,
          'download_ipr_document',
          '',
          setIsError,
        ),
      [resourceUrl, docType],
    );

    return (
      <div className='dmx-iprDocumentItem'>
        <FileIconWithBadge ext='pdf' />
        <span className='dmx-iprDocumentLabel'>
          <StyleGuideLink {...downloadLink} severity='colorful'>
            {label}
          </StyleGuideLink>
          {note && <span className='sg-a-d-b sg-u-type-sml sg-u-c-body-darkest'>{note}</span>}
        </span>
        {isError && (
          <DangerBadge>
            <FormattedMessage {...iprDocumentMessages.downloadError} />
          </DangerBadge>
        )}
      </div>
    );
  },
);
